import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=3b910d1c&"
import script from "./ButtonList.vue?vue&type=script&lang=ts&"
export * from "./ButtonList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports